module.exports = __webpack_public_path__ + "img/w.7e480e41.jpg";